import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";

import Platform from "./pages/Platform";
import Infrastructure from "./pages/Infrastructure";
import Sectors from "./pages/Sectors";
import Story from "./pages/Story";
import Footer from "./pages/Footer";

function App() {
  return (
    <Router>
       <div className="bg-slate-50 min-h-screen ">
        <Header />

        <Routes>
          <Route path="/" element={<Platform />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/sectors" element={<Sectors />} />
          <Route path="/story" element={<Story />} />
          <Route path="/footer" element={<Footer />} />
         </Routes>
      </div>
    </Router>
  );
}
export default App;